/**
 * The running app's version — the number the footer shows.
 *
 * It comes from client/web/package.json, baked in at build time by Vite (`define` in
 * vite.config.ts). The niobe-devops deploy stage owns it: every deploy bumps the patch in
 * client/web/package.json AND backend/package.json, commits that bump onto the target branch and
 * puts the `deploy-<stamp>` tag on it — so one version number identifies the whole shipped
 * product, and `git show <deploy-tag>:client/web/package.json` answers "what is live".
 *
 * Not to be confused with the curated release NOTES in lib/releases.ts: those describe what
 * changed for a feature release and are written by hand; this is the build's identity.
 */
export const APP_VERSION: string = __APP_VERSION__
